"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fsmoData = exports.fsmData = void 0;
const reverse_1 = __importDefault(require("lodash/reverse"));
const slice_1 = __importDefault(require("lodash/slice"));
const sortBy_1 = __importDefault(require("lodash/sortBy"));
const values_1 = __importDefault(require("lodash/values"));
const fsmData = (datasetRaw = [], params = {}) => {
    if (params.limit != null && params.takeFirst != null) {
        throw new Error('Cannot have a `limit` and a `takeFirst` on the same operation');
    }
    let datasetArrayOutput = fsmDataArrayInner((0, values_1.default)(datasetRaw), {
        filter: params.filter,
        sort: params.sort,
        map: params.map,
        postFilter: params.postFilter,
        postSort: params.postSort,
        reverse: params.reverse,
        limit: params.limit ?? (params.takeFirst ? 1 : undefined),
    });
    if (datasetArrayOutput.length === 0 && params.takeFirst && params.map) {
        datasetArrayOutput = [params.map(null, 1)];
    }
    return params.takeFirst
        ? datasetArrayOutput[0]
        : datasetArrayOutput;
};
exports.fsmData = fsmData;
const fsmoData = (data, p) => {
    const data1 = Object.entries(data);
    const data2 = fsmDataArrayInner(data1, {
        filter: p.filter ? ([k, v]) => p.filter?.(v, k) ?? false : undefined,
        sort: p.sort ? ([k, v]) => p.sort?.(v, k) : undefined,
        map: ([k, v]) => p.map?.(v, k) ?? [k, v],
        postFilter: p.postFilter
            ? ([k, v]) => p.postFilter?.(v, k) ?? false
            : undefined,
        postSort: p.postSort ? ([k, v]) => p.postSort?.(v, k) : undefined,
        reverse: p.reverse,
        limit: p.limit,
    });
    return (p.valuesOnly === true
        ? data2.map(x => x[1])
        : Object.fromEntries(data2));
};
exports.fsmoData = fsmoData;
const fsmDataArrayInner = (data, p) => {
    let data1 = data;
    data1 = !p.filter ? data1 : data1.filter(p.filter);
    data1 = !p.sort ? data1 : (0, sortBy_1.default)(data1, p.sort);
    let hasRevCap = false;
    if (p.postFilter == null && p.postSort == null && p.limit != null) {
        data1 = p.reverse ? (0, reverse_1.default)(data1) : data1;
        data1 = (0, slice_1.default)(data1, 0, p.limit);
        hasRevCap = true;
    }
    let data2 = p.map ? data1.map(p.map) : data1;
    data2 = !p.postFilter ? data2 : data2.filter(p.postFilter);
    data2 = !p.postSort ? data2 : (0, sortBy_1.default)(data2, p.postSort);
    if (!hasRevCap) {
        data2 = p.reverse ? (0, reverse_1.default)(data2) : data2;
        data2 = !p.limit ? data2 : (0, slice_1.default)(data2, 0, p.limit);
    }
    return data2;
};
//# sourceMappingURL=fsm-data.js.map